import { Button } from '@/shadcn/button';
import { cn } from '@/shadcn/lib/utils';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger
} from '@/shadcn/tooltip';
import { Star } from 'lucide-react';

type Props = {
  isFavorite?: boolean;
  onChange: (value: boolean) => void;
  dataCy: string;
} & React.HTMLAttributes<HTMLButtonElement>;

export const AddToFavorite = ({
  isFavorite,
  onChange,
  className,
  dataCy
}: Props) => {
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    onChange(!isFavorite);
  };

  const label = isFavorite ? 'Remove from favorites' : 'Add to favorites';

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            size="icon"
            variant="ghost"
            onClick={handleClick}
            className={cn('group', className)}
            aria-label={label}
            data-cy={dataCy}
            data-state={isFavorite ? 'active' : 'inactive'}
          >
            <Star
              strokeWidth={2}
              className={cn(
                'text-foreground transition-colors',
                isFavorite &&
                  'group-hover:fill-foreground group-hover:text-foreground fill-yellow-500 text-yellow-500'
              )}
            />
          </Button>
        </TooltipTrigger>
        <TooltipContent>{label}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
